import React from 'react';
import { Col as AntCol, ColProps } from 'antd';

function Col(props: ColProps) {
  return <AntCol {...props} />;
}

export default Col;
